import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import ui_kit from './views/ui_kit.vue';

import store from './store';
import i18n from './i18n';
Vue.use(Router);

import auth from './views/Auth.vue';
import pwd_recover from './views/pwd_recover.vue';
import study from './views/Study.vue';
import study_business_plus from './views/Study_businessPlus.vue';
import knowledge_check from './views/Knowledge_check.vue';
import study_plan from './views/Study_plan.vue';
import course_content from './views/Course_info.vue';
import knowledge_check_detail from './views/Knowledge_check_detail.vue';
import profile from './views/Profile.vue';
import company_profile from './views/Company_profile.vue';
import news_main from './views/News_main.vue';
import news_descript from './views/News_detail.vue';
import notifications from './views/Notifications.vue';
import note_edit from './views/Notifications_edit.vue';
import database from './views/Database.vue';
import ideas_bank from './views/Ideas_bank.vue';
import idea_detail from './components/view_blocks/Ideas_bank/Idea_detail_wrap.vue';
import live_news from './views/Live_news.vue';
import contact from './views/Contact.vue';
import faq from './views/FAQ.vue';
import favourites from './views/Favourites.vue';
import rating from './views/Rating.vue';
import points_history from './views/Points_history.vue';
import prize_shop from './views/Prize_shop.vue';
import prize_successful_order from './views/Prize_successful_order.vue';
import prize_detail from './views/PrizeDetail.vue';
import prize_order from './views/PrizeOrder.vue';
import prize_basket from './views/Prize_basket.vue';
import employee_study from './views/Employee_study.vue';
import employee_study_organizations from './components/view_blocks/Employee_study/Employee_study_pages/Employee_study_organizations.vue';
import employee_study_users from './components/view_blocks/Employee_study/Employee_study_pages/Employee_study_users.vue';
import employee_study_courses from './components/view_blocks/Employee_study/Employee_study_pages/Employee_study_courses.vue';
import users from './views/Users.vue';
import P404 from './views/404.vue';
import P403 from './views/403.vue';
import Blocked from './views/Blocked.vue';
import OnModeration from './views/OnModeration.vue';
import activity from './views/Activity.vue';
import events from './views/Events.vue';
import recoverTrue from './views/pwd_recover_true';
import api from '@/api';
import training_management  from './views/Training_management.vue';

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash, offset: {x: 0, y: 60}};
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return {x: 0, y: 0};
    }
  },

  routes: [
    {
      path     : '/',
      component: Home,
      name     : 'home',
      meta     : {requiresAuth: true, title: 'Главная страница'},
    },
    {
      path     : '/ui-kit',
      component: ui_kit,
      name     : 'ui_kit',
      meta     : {requiresAuth: true, title: 'Ui Kit'},
    },
    {
      path     : '/auth',
      name     : 'auth',
      component: auth,
      meta     : {
        requiresAuth: true,
        title       : 'Авторизация пользователей - ЛУКОЙЛ АКАДЕМИЯ',
        description :
            'Авторизация в информационно-обучающем портале ООО «ЛЛК-Интернешнл», ЛУКОЙЛ АКАДЕМИЯ',
      },
    },
    {
      path     : '/pwd_recover',
      name     : 'pwd_recover',
      component: pwd_recover,
      meta     : {requiresAuth: true, title: 'Восстановление пароля'},
    },
    {
      path     : '/study',
      name     : 'study',
      component: study,
      meta     : {requiresAuth: true, title: 'Обучение'},
    },
    {
      path     : '/study_plan',
      name     : 'study_plan',
      component: study_plan,
      meta     : {requiresAuth: true, title: 'Планирование обучения'},
    },
    {
      path     : '/study/:id',
      name     : 'course_content',
      component: course_content,
      props    : true,
      meta     : {requiresAuth: true, title: 'Обучение'},
    },
    {
      path     : '/study_business_plus',
      name     : 'study_business_plus',
      component: study_business_plus,
      meta     : {requiresAuth: true, title: 'Курсы Бизнес+'},
    },
    {
      path     : '/knowledge_check',
      name     : 'knowledge_check',
      component: knowledge_check,
      meta     : {requiresAuth: true, title: 'Проверка знаний'},
    },
    {
      path     : '/knowledge_check/:id',
      name     : 'knowledge_check_detail',
      component: knowledge_check_detail,
      meta     : {requiresAuth: true, title: 'Проверка знаний'},
    },
    {
      path     : '/profile',
      name     : 'profile',
      component: profile,
      meta     : {requiresAuth: true, title: 'Профиль'},
    },
    {
      path     : '/profile/:id',
      name     : 'profile_other',
      component: profile,
      meta     : {requiresAuth: true, title: 'Профиль'},
    },
    {
      path     : '/recover_true',
      name     : 'recover_true',
      component: recoverTrue,
      meta     : {requiresAuth: false, title: 'Пароль отправлен'},
    },
    {
      path     : '/company_profile',
      name     : 'company_profile',
      component: company_profile,
      meta     : {requiresAuth: true, title: 'Страница компании'},
    },
    {
      path     : '/company_profile/:id',
      name     : 'company_other',
      component: company_profile,
      meta     : {requiresAuth: true, title: 'Страница компании'},
    },
    {
      path     : '/news_main',
      name     : 'news_main',
      component: news_main,
      meta     : {requiresAuth: true, title: 'Новости и мероприятия'},
    },
    {
      path     : '/news_descript/:id',
      name     : 'news_descript',
      component: news_descript,
      meta     : {requiresAuth: true, title: 'Новости'},
      beforeEnter(to, from, next) {
        const {params} = to;
        const {id} = params;
        if (id) {
          next();
        } else {
          router.push(from.path);
        }
      },
    },
    {
      path     : '/notifications',
      name     : 'notifications',
      component: notifications,
      meta     : {requiresAuth: true, title: 'Мои уведомления'},
    },
    {
      path     : '/note_edit',
      name     : 'note_edit',
      component: note_edit,
      meta     : {requiresAuth: true, title: 'Настройка уведомлений'},
    },
    {
      path     : '/database',
      name     : 'database',
      component: database,
      meta     : {requiresAuth: true, title: 'База знаний'},
    },
    {
      path     : '/ideas_bank',
      name     : 'ideas_bank',
      component: ideas_bank,
      meta     : {requiresAuth: true, title: 'Банк идей'},
    },
    {
      path     : '/ideas_bank/:id',
      name     : 'idea_detail',
      component: idea_detail,
      props    : true,
      meta     : {requiresAuth: true, title: 'Банк идей'},
    },
    {
      path     : '/live_news',
      name     : 'live_news',
      component: live_news,
      meta     : {requiresAuth: true, title: 'Живая лента'},
    },
    {
      path     : '/contact',
      name     : 'contact',
      component: contact,
      meta     : {requiresAuth: true, title: 'Правила обучения и обратная связь'},
    },
    {
      path     : '/faq',
      name     : 'faq',
      component: faq,
      meta     : {requiresAuth: true, title: 'Вопрос-ответ'},
    },
    {
      path     : '/favourites',
      name     : 'favourites',
      component: favourites,
      meta     : {requiresAuth: true, title: 'Избранное'},
    },
    {
      path     : '/rating',
      name     : 'rating',
      component: rating,
      meta     : {requiresAuth: true, title: 'Рейтинг и баллы'},
    },
    {
      path     : '/rating/points_history',
      name     : 'points_history',
      component: points_history,
      meta     : {requiresAuth: true, title: 'История начисления баллов'},
    },
    {
      path     : '/prize_shop',
      name     : 'prize_shop',
      component: prize_shop,
      meta     : {requiresAuth: true, title: 'Каталог призов'},
    },
    {
      path     : '/prize_successful_order',
      name     : 'prize_successful_order',
      component: prize_successful_order,
      meta     : {requiresAuth: true, title: 'Успешный заказ'},
    },
    {
      path     : '/prize_shop/:id',
      name     : 'prize_detail',
      props    : true,
      component: prize_detail,
      meta     : {requiresAuth: true, title: 'Каталог призов'},
    },
    {
      path     : '/prize_order',
      name     : 'prize_order',
      component: prize_order,
      meta     : {requiresAuth: true, title: 'Мои заказы'},
    },
    {
      path     : '/prize_basket/',
      name     : 'prize_basket',
      component: prize_basket,
      meta     : {requiresAuth: true, title: 'Корзина'},
    },
    {
      path     : '/employee_study',
      name     : 'employee_study',
      component: employee_study,
      meta     : {requiresAuth: true, title: 'Статистика'},
    },
    {
      path     : '/employee_study/:directorate',
      name     : 'employee_study_organizations',
      component: employee_study_organizations,
      meta     : {requiresAuth: true, title: 'Статистика'},
    },
    {
      path     : '/employee_study/:directorate/:organization',
      name     : 'employee_study_users',
      component: employee_study_users,
      meta     : {requiresAuth: true, title: 'Статистика'},
    },
    {
      path     : '/employee_study/:directorate/:organization/:user',
      name     : 'employee_study_courses',
      component: employee_study_courses,
      meta     : {requiresAuth: true, title: 'Статистика'},
    },
    {
      path     : '/users',
      name     : 'users',
      component: users,
      meta     : {requiresAuth: true, title: 'Пользователи и организации'},
    },
    {
      path     : '/404',
      name     : '404',
      component: P404,
      meta     : {requiresAuth: true, title: 'Страница не найдена'},
    },
    {
      path     : '/403',
      name     : '403',
      component: P403,
      meta     : {title: 'Страница недоступна'},
    },
    {
      path     : '/blocked',
      name     : 'blocked',
      component: Blocked,
      meta     : {title: 'Страница недоступна'},
    },
    {
      path     : '/moderation',
      name     : 'moderation',
      component: OnModeration,
      meta     : {title: 'Страница недоступна'},
    },
    {
      path     : '/activity',
      name     : 'activity',
      component: activity,
      meta     : {requiresAuth: true, title: 'Активность'},
    },
    {
      path     : '/events',
      name     : 'events',
      component: events,
      meta     : {requiresAuth: true, title: 'Мои мероприятия'},
    },
    {
      path     : '/training_management',
      name     : 'training_management',
      component: training_management,
      meta     : {requiresAuth: true, title: 'Управление обучением'},
    },
    {
      path    : '*',
      redirect: '/404',
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.name !== 'prize_detail') store.commit('common/LOADING_ON');
  if (to.meta.requiresAuth && !store.state.autorisation.user_id) {
    try {
      const authData = await api.user.is_auth({
        code : to.query.code,
        state: to.query.state,
      });
      if (authData.data.status === 'success' || authData.data.status === 200) {
        store.commit('autorisation/SET_USER_ID', authData.data.id);
        await store.dispatch('autorisation/get_load_user');
        router.replace({query: null});
        return next();
      }
      if (authData.data.status === 'forbidden' || authData.data.status === 403) {
        const userData = authData.data.userData;
        await store.dispatch('authUserData/setAuthUserData', userData)
        router.push({name: '403'});
      }
      if (authData.data.status === 'blocked') {
        console.debug("authData", authData)
        console.debug("authData", authData.data.userData)
        const userData = authData.data.userData;
        await store.dispatch('authUserData/setAuthUserData', userData)
        router.push({name: 'blocked'});
      }
      if (authData.data.status === 'moderation') {
        const userData = authData.data.userData;
        await store.dispatch('authUserData/setAuthUserData', userData)
        router.push({name: 'moderation'});
      }
      if (authData.data.status === 'notfound') {
        console.debug(authData.data)
        window.location.href = authData.data.url;
        localStorage.clear();
        return;
      }
      if (authData.data.status === 'unauthorized') {
        console.debug(authData.data)
        window.location.href = authData.data.url;
        localStorage.clear();
        return;
      }
      // if (authData.data.status === 401) {
      //   window.location.href = authData.data.url;
      //   localStorage.clear();
      //   return;
      // }
      // if (authData.data.status === 403) {
      //   router.push({name: '403'});
      //   localStorage.clear();
      // }
      return next();
    } catch (e) {
      console.log(e.message);
      return router.push({name: 'auth'});
    } finally {
      store.commit('common/LOADING_OFF');
    }
  } else {
    document
        .querySelector('meta[name="description"]')
        .setAttribute(
            'content',
            i18n.t(to.meta.description) ||
            i18n.t('Информационно-обучающий портал ООО «ЛЛК-Интернешнл»')
        );
    document.title = i18n.t(to.meta.title) || i18n.t('ЛУКОЙЛ');
    store.commit('common/LOADING_OFF');
    return next();
  }
});

export default router;

